export enum KnowledgeCheckSort {
  Name = 1
}